import { VisaImagesModel } from "./VisaImagesModel";
import { VisaRequirementModel } from "./VisaRequirementModel";

export class VisaModel{
    id?: number;
    titleAr?:string;
    titleEn?:string;
    titleFr?:string;
    descriptionEn?:string;
    descriptionAr?:string;
    descriptionFr?:string;
    countryId?: number;
    userId?: number;
    visaImagsList?:VisaImagesModel[]
    visaRequirementList?:VisaRequirementModel[]
    images?:string;
    countryNameAr?:string;
    countryNameEn?:string;



    constructor(item?:VisaModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.images = item.images? item.images:'';
        this.titleAr = item.titleAr? item.titleAr:'';
        this.titleEn = item.titleEn? item.titleEn:'';
        this.titleFr = item.titleFr? item.titleFr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.descriptionFr = item.descriptionFr? item.descriptionFr:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.countryId = item.countryId? item.countryId:0;
        this.userId = item.userId? item.userId:0;
        this.visaImagsList = item.visaImagsList? item.visaImagsList:[];
        this.visaRequirementList = item.visaRequirementList? item.visaRequirementList:[];
        this.countryNameAr = item.countryNameAr? item.countryNameAr:'';
        this.countryNameEn = item.countryNameEn? item.countryNameEn:'';

    }

}